'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PlanCode$() {
  this.c7M = null;
  this.c7N = false;
  this.c7K = null;
  this.c7L = false;
  this.Ye = null;
  this.c7J = null;
  this.c7I = null;
  $n_Lpresto_types$PlanCode$ = this;
  this.Ye = ($m_Lpresto_types$PlanCode$(), "freemium_2fa");
  this.c7J = ($m_Lpresto_types$PlanCode$(), "presto_sign");
  this.c7I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Set$().ku($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_T.r().C)([this.c7J])));
}
export { $c_Lpresto_types$PlanCode$ as $c_Lpresto_types$PlanCode$ };
$p = $c_Lpresto_types$PlanCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PlanCode$;
/** @constructor */
function $h_Lpresto_types$PlanCode$() {
}
export { $h_Lpresto_types$PlanCode$ as $h_Lpresto_types$PlanCode$ };
$h_Lpresto_types$PlanCode$.prototype = $p;
$p.cHB = (function() {
  if ((!this.c7N)) {
    this.c7M = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7N = true;
  }
  return this.c7M;
});
$p.adg = (function() {
  if ((!this.c7L)) {
    this.c7K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c7L = true;
  }
  return this.c7K;
});
var $d_Lpresto_types$PlanCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PlanCode$, "presto.types$PlanCode$", ({
  a18: 1,
  D: 1
}));
export { $d_Lpresto_types$PlanCode$ as $d_Lpresto_types$PlanCode$ };
var $n_Lpresto_types$PlanCode$;
function $m_Lpresto_types$PlanCode$() {
  if ((!$n_Lpresto_types$PlanCode$)) {
    $n_Lpresto_types$PlanCode$ = new $c_Lpresto_types$PlanCode$();
  }
  return $n_Lpresto_types$PlanCode$;
}
export { $m_Lpresto_types$PlanCode$ as $m_Lpresto_types$PlanCode$ };
//# sourceMappingURL=presto.types$-Plan-Code$.js.map
